import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  pointersContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
  },
  pointersLines: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    paddingRight: 2,
    position: 'relative',
  },
  pointerBlack: {
    position: 'absolute',
    top: 0,
    width: '0%',
    height: '94%',
    borderRightWidth: 1,
    borderRightStyle: 'dotted',
    borderRightColor: '#000',
    opacity: 0.3,
  }
});

const Pointers = ({ averagePoint }) => {

  const xPos = ((averagePoint - 1) / 4) * 100;

  return (
    <View style={styles.pointersContainer}>
      <View style={styles.pointersLines}>
        <View style={[styles.pointerBlack, { left: `${xPos}%` }]}></View>
      </View>
    </View> 
  )
}

export default Pointers